import React from 'react';
import './index.scss';

export interface SpinnerProps {
  className?: string;
  color?: string;
}

function Spinner({ className = '', color }: SpinnerProps) {
  return (
    <div className={`spinner-component ${className}`}>
      <div
        className="spinner-component-bounce1"
        style={{ backgroundColor: color }}
      ></div>
      <div
        className="spinner-component-bounce2"
        style={{ backgroundColor: color }}
      ></div>
      <div
        className="spinner-component-bounce3"
        style={{ backgroundColor: color }}
      ></div>
    </div>
  );
}

export default Spinner;
